// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 1299px) {
    .Footer_wrap__VjkLj {
        width: 100vw;
        height: 267px;
        background-color: #F4F4F4;
        padding: 33px 0 30px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        gap: 15px;
    }

    .Footer_topContainer__1FH\\+W{
        width: 100vw;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        height: 60px;
        position: relative;
    }

    .Footer_bottomContainer__-\\+4PP {
        width: 100vw;
        display: flex;
        padding: 0 20px;
        flex-direction: column;
        justify-content: space-between;
        gap: 52px;
    }

    .Footer_topLogo__fAq7F img {
        width: 80px;
        display: block;
    }

    .Footer_topLink__j4tAP {
        display: flex;
        align-items: center;
        height: inherit;
        display: none;
    }

    .Footer_topLinkItem__0oQeE {
        height: inherit;
        position: relative;
    }

    .Footer_topLinkItem__0oQeE > a,
    .Footer_topLinkItem__0oQeE > span {
        text-decoration: none;
        color: #222222;
        font-size: 20px;
        font-weight: 500;
        padding: 0 32px;
        display: flex;
        align-items: flex-end;
        height: inherit;
    }

    .Footer_hoverItem__qvjav {
        margin-top: 39px;
        text-align: center;
        display: flex;
        flex-flow: column;
        gap: 11px;
    }

    .Footer_hoverItem__qvjav > a > span {
        display: block;
        color: #222222;
        font-size: 18px;
    }

    .Footer_topHr__fOoke {
        width: 1300px;
        height: 0;
        border-top: 1px solid #222222;
        opacity: 0.16;
        position: absolute;
        top: 78px;
        margin: 0;
        display: none;
    }

    .Footer_bottomSelect__VfOh4 {
        position: relative;
        margin-top: auto;
    }

    .Footer_bottomInfo__hRZH8 > span {
        line-height: 16px;
        font-size: 10px;
        color: #5A5A5A;
        font-weight: 500;
    }

    .Footer_postContainer__9N-\\+Z {
        width: 20px;
        height: 20px;
        position: absolute;
        display: flex;
        gap: 10px;
        left: 0;
        top: -36px;
        z-index: 1;
    }

    .Footer_postContainer__9N-\\+Z > img {
        width: 24px;
        height: 24px;
        cursor: pointer;
    }

    .Footer_selectBox__kMZX1 {
        width: 152px;
        height: 32px;
        color: #FFFFFF;
        background-color: #222222;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 14px 0 10px;
        cursor: pointer;
        transition: 0.3s ease-out;
        font-size: 10px;
    }

    .Footer_selectBox__kMZX1 > img {
        width: 6px;
        transition: 0.3s ease-out;
    }

    .Footer_show__8J2Ez{
        rotate: 180deg;
    }

    .Footer_selectBoxHr__AvtEY {
        margin: 0;
        border: none;
        width: 132px;
        border-top: 1px solid #FFFFFF;
        opacity: 0.2;
    }

    .Footer_selectBoxWrap__0MdeH {
        position: absolute;
        top: -83px;
        overflow: hidden;
    }

    .Footer_selectBoxContent__fKhqp {
        background-color: #222222;
        color: #FFFFFF;
        display: flex;
        flex-flow: column;
        padding: 10px 10px 0;
        gap: 12px;
        top: 0;
        width: 152px;
        transition: 0.3s ease-out;
        transform: translateY(83px);
        font-size: 10px;
        position: relative;
        z-index: 2;
    }

    .Footer_selectBoxContent__fKhqp.Footer_open__-WlIi {
        transform: translateY(0);
    }

    .Footer_selectBoxContent__fKhqp > span {
        transition: 0.3s ease-out;
        opacity: 0;
        cursor: pointer;
    }

    .Footer_selectBoxContent__fKhqp.Footer_open__-WlIi > span {
        opacity: 1;
    }
}
@media only screen and (min-width: 1300px) {
    .Footer_wrap__VjkLj {
        width: 100%;
        height: 450px;
        background-color: #F4F4F4;
        padding: 68px 0 60px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }

    .Footer_topContainer__1FH\\+W{
        width: 1300px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        height: 60px;
        position: relative;
    }

    .Footer_bottomContainer__-\\+4PP {
        width: 1300px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }

    .Footer_topLogo__fAq7F {
        padding-left: 32px;
        align-items: center;
        display: flex;
    }

    .Footer_topLogo__fAq7F img {
        width: 130px;
        display: block;
    }

    .Footer_topLink__j4tAP {
        display: flex;
        align-items: center;
        height: inherit;
    }

    .Footer_topLinkItem__0oQeE {
        height: inherit;
        position: relative;
    }

    .Footer_topLinkItem__0oQeE > a,
    .Footer_topLinkItem__0oQeE > span {
        text-decoration: none;
        color: #222222;
        font-size: 20px;
        font-weight: 500;
        padding: 0 32px;
        display: flex;
        align-items: center;
        height: inherit;
    }

    .Footer_hoverItem__qvjav {
        margin-top: 39px;
        text-align: center;
        display: flex;
        flex-flow: column;
        gap: 11px;
    }

    .Footer_hoverItem__qvjav > a > span {
        display: block;
        color: #222222;
        font-size: 18px;
    }

    .Footer_topHr__fOoke {
        width: 1300px;
        height: 0;
        border-top: 1px solid #222222;
        opacity: 0.16;
        position: absolute;
        top: 78px;
        margin: 0;
    }

    .Footer_bottomSelect__VfOh4 {
        position: relative;
        height: 45px;
        margin-top: auto;
    }

    .Footer_bottomInfo__hRZH8 > span {
        line-height: 22px;
        font-size: 14px;
        color: #5A5A5A;
        font-weight: 500;
    }

    .Footer_postContainer__9N-\\+Z {
        width: 32px;
        height: 32px;
        position: absolute;
        display: flex;
        gap: 10px;
        top: 50%;
        transform: translateY(-50%);
        left: -188px;
    }

    .Footer_postContainer__9N-\\+Z > img {
        width: 32px;
        height: 32px;
        cursor: pointer;
    }

    .Footer_selectBox__kMZX1 {
        width: 200px;
        height: 45px;
        color: #FFFFFF;
        background-color: #222222;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        cursor: pointer;
        transition: 0.3s ease-out;
    }

    .Footer_selectBox__kMZX1 > img {
        width: 12px;
        transition: 0.3s ease-out;
    }

    .Footer_show__8J2Ez{
        rotate: 180deg;
    }

    .Footer_selectBoxHr__AvtEY {
        margin: 0;
        border: none;
        width: 168px;
        border-top: 1px solid #FFFFFF;
        opacity: 0.2;
    }

    .Footer_selectBoxWrap__0MdeH {
        position: absolute;
        top: -106px;
        overflow: hidden;
    }

    .Footer_selectBoxContent__fKhqp {
        background-color: #222222;
        color: #FFFFFF;
        display: flex;
        flex-flow: column;
        padding: 12px 16px 0 16px;
        gap: 12px;
        top: 0;
        width: 200px;
        transition: 0.3s ease-out;
        transform: translateY(108px);
    }

    .Footer_selectBoxContent__fKhqp.Footer_open__-WlIi {
        transform: translateY(0);
    }

    .Footer_selectBoxContent__fKhqp > span {
        transition: 0.3s ease-out;
        opacity: 0;
        cursor: pointer;
    }

    .Footer_selectBoxContent__fKhqp.Footer_open__-WlIi > span {
        opacity: 1;
    }

    .Footer_doubleContent__8VXy0 {
        color: #222222;
        font-size: 18px;
    }

    .Footer_doubleContent__8VXy0 > a > span {
        display: block;
        font-size: 14px;
        margin-top: 4px;
        text-decoration: none;
        color: #222222;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Footer.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,YAAY;QACZ,aAAa;QACb,yBAAyB;QACzB,oBAAoB;QACpB,aAAa;QACb,iBAAiB;QACjB,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,aAAa;QACb,8BAA8B;QAC9B,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,eAAe;QACf,sBAAsB;QACtB,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;;QAEI,qBAAqB;QACrB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,aAAa;QACb,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;QACb,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,cAAc;QACd,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,6BAA6B;QAC7B,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,SAAS;QACT,OAAO;QACP,UAAU;QACV,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,cAAc;QACd,yBAAyB;QACzB,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,sBAAsB;QACtB,eAAe;QACf,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,6BAA6B;QAC7B,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,aAAa;QACb,iBAAiB;QACjB,oBAAoB;QACpB,SAAS;QACT,MAAM;QACN,YAAY;QACZ,yBAAyB;QACzB,2BAA2B;QAC3B,eAAe;QACf,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,WAAW;QACX,aAAa;QACb,yBAAyB;QACzB,oBAAoB;QACpB,aAAa;QACb,iBAAiB;QACjB,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,cAAc;QACd,aAAa;QACb,8BAA8B;QAC9B,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;;QAEI,qBAAqB;QACrB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;QACb,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,cAAc;QACd,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,6BAA6B;QAC7B,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,SAAS;QACT,QAAQ;QACR,2BAA2B;QAC3B,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,cAAc;QACd,yBAAyB;QACzB,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,eAAe;QACf,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,6BAA6B;QAC7B,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,aAAa;QACb,iBAAiB;QACjB,yBAAyB;QACzB,SAAS;QACT,MAAM;QACN,YAAY;QACZ,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,eAAe;QACf,qBAAqB;QACrB,cAAc;IAClB;AACJ","sourcesContent":["@media only screen and (max-width: 1299px) {\n    .wrap {\n        width: 100vw;\n        height: 267px;\n        background-color: #F4F4F4;\n        padding: 33px 0 30px;\n        display: flex;\n        flex-flow: column;\n        justify-content: space-between;\n        gap: 15px;\n    }\n\n    .topContainer{\n        width: 100vw;\n        padding: 0 20px;\n        display: flex;\n        justify-content: space-between;\n        height: 60px;\n        position: relative;\n    }\n\n    .bottomContainer {\n        width: 100vw;\n        display: flex;\n        padding: 0 20px;\n        flex-direction: column;\n        justify-content: space-between;\n        gap: 52px;\n    }\n\n    .topLogo img {\n        width: 80px;\n        display: block;\n    }\n\n    .topLink {\n        display: flex;\n        align-items: center;\n        height: inherit;\n        display: none;\n    }\n\n    .topLinkItem {\n        height: inherit;\n        position: relative;\n    }\n\n    .topLinkItem > a,\n    .topLinkItem > span {\n        text-decoration: none;\n        color: #222222;\n        font-size: 20px;\n        font-weight: 500;\n        padding: 0 32px;\n        display: flex;\n        align-items: flex-end;\n        height: inherit;\n    }\n\n    .hoverItem {\n        margin-top: 39px;\n        text-align: center;\n        display: flex;\n        flex-flow: column;\n        gap: 11px;\n    }\n\n    .hoverItem > a > span {\n        display: block;\n        color: #222222;\n        font-size: 18px;\n    }\n\n    .topHr {\n        width: 1300px;\n        height: 0;\n        border-top: 1px solid #222222;\n        opacity: 0.16;\n        position: absolute;\n        top: 78px;\n        margin: 0;\n        display: none;\n    }\n\n    .bottomSelect {\n        position: relative;\n        margin-top: auto;\n    }\n\n    .bottomInfo > span {\n        line-height: 16px;\n        font-size: 10px;\n        color: #5A5A5A;\n        font-weight: 500;\n    }\n\n    .postContainer {\n        width: 20px;\n        height: 20px;\n        position: absolute;\n        display: flex;\n        gap: 10px;\n        left: 0;\n        top: -36px;\n        z-index: 1;\n    }\n\n    .postContainer > img {\n        width: 24px;\n        height: 24px;\n        cursor: pointer;\n    }\n\n    .selectBox {\n        width: 152px;\n        height: 32px;\n        color: #FFFFFF;\n        background-color: #222222;\n        font-weight: 500;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0 14px 0 10px;\n        cursor: pointer;\n        transition: 0.3s ease-out;\n        font-size: 10px;\n    }\n\n    .selectBox > img {\n        width: 6px;\n        transition: 0.3s ease-out;\n    }\n\n    .show{\n        rotate: 180deg;\n    }\n\n    .selectBoxHr {\n        margin: 0;\n        border: none;\n        width: 132px;\n        border-top: 1px solid #FFFFFF;\n        opacity: 0.2;\n    }\n\n    .selectBoxWrap {\n        position: absolute;\n        top: -83px;\n        overflow: hidden;\n    }\n\n    .selectBoxContent {\n        background-color: #222222;\n        color: #FFFFFF;\n        display: flex;\n        flex-flow: column;\n        padding: 10px 10px 0;\n        gap: 12px;\n        top: 0;\n        width: 152px;\n        transition: 0.3s ease-out;\n        transform: translateY(83px);\n        font-size: 10px;\n        position: relative;\n        z-index: 2;\n    }\n\n    .selectBoxContent.open {\n        transform: translateY(0);\n    }\n\n    .selectBoxContent > span {\n        transition: 0.3s ease-out;\n        opacity: 0;\n        cursor: pointer;\n    }\n\n    .selectBoxContent.open > span {\n        opacity: 1;\n    }\n}\n@media only screen and (min-width: 1300px) {\n    .wrap {\n        width: 100%;\n        height: 450px;\n        background-color: #F4F4F4;\n        padding: 68px 0 60px;\n        display: flex;\n        flex-flow: column;\n        justify-content: space-between;\n    }\n\n    .topContainer{\n        width: 1300px;\n        margin: 0 auto;\n        display: flex;\n        justify-content: space-between;\n        height: 60px;\n        position: relative;\n    }\n\n    .bottomContainer {\n        width: 1300px;\n        margin: 0 auto;\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .topLogo {\n        padding-left: 32px;\n        align-items: center;\n        display: flex;\n    }\n\n    .topLogo img {\n        width: 130px;\n        display: block;\n    }\n\n    .topLink {\n        display: flex;\n        align-items: center;\n        height: inherit;\n    }\n\n    .topLinkItem {\n        height: inherit;\n        position: relative;\n    }\n\n    .topLinkItem > a,\n    .topLinkItem > span {\n        text-decoration: none;\n        color: #222222;\n        font-size: 20px;\n        font-weight: 500;\n        padding: 0 32px;\n        display: flex;\n        align-items: center;\n        height: inherit;\n    }\n\n    .hoverItem {\n        margin-top: 39px;\n        text-align: center;\n        display: flex;\n        flex-flow: column;\n        gap: 11px;\n    }\n\n    .hoverItem > a > span {\n        display: block;\n        color: #222222;\n        font-size: 18px;\n    }\n\n    .topHr {\n        width: 1300px;\n        height: 0;\n        border-top: 1px solid #222222;\n        opacity: 0.16;\n        position: absolute;\n        top: 78px;\n        margin: 0;\n    }\n\n    .bottomSelect {\n        position: relative;\n        height: 45px;\n        margin-top: auto;\n    }\n\n    .bottomInfo > span {\n        line-height: 22px;\n        font-size: 14px;\n        color: #5A5A5A;\n        font-weight: 500;\n    }\n\n    .postContainer {\n        width: 32px;\n        height: 32px;\n        position: absolute;\n        display: flex;\n        gap: 10px;\n        top: 50%;\n        transform: translateY(-50%);\n        left: -188px;\n    }\n\n    .postContainer > img {\n        width: 32px;\n        height: 32px;\n        cursor: pointer;\n    }\n\n    .selectBox {\n        width: 200px;\n        height: 45px;\n        color: #FFFFFF;\n        background-color: #222222;\n        font-weight: 500;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0 16px;\n        cursor: pointer;\n        transition: 0.3s ease-out;\n    }\n\n    .selectBox > img {\n        width: 12px;\n        transition: 0.3s ease-out;\n    }\n\n    .show{\n        rotate: 180deg;\n    }\n\n    .selectBoxHr {\n        margin: 0;\n        border: none;\n        width: 168px;\n        border-top: 1px solid #FFFFFF;\n        opacity: 0.2;\n    }\n\n    .selectBoxWrap {\n        position: absolute;\n        top: -106px;\n        overflow: hidden;\n    }\n\n    .selectBoxContent {\n        background-color: #222222;\n        color: #FFFFFF;\n        display: flex;\n        flex-flow: column;\n        padding: 12px 16px 0 16px;\n        gap: 12px;\n        top: 0;\n        width: 200px;\n        transition: 0.3s ease-out;\n        transform: translateY(108px);\n    }\n\n    .selectBoxContent.open {\n        transform: translateY(0);\n    }\n\n    .selectBoxContent > span {\n        transition: 0.3s ease-out;\n        opacity: 0;\n        cursor: pointer;\n    }\n\n    .selectBoxContent.open > span {\n        opacity: 1;\n    }\n\n    .doubleContent {\n        color: #222222;\n        font-size: 18px;\n    }\n\n    .doubleContent > a > span {\n        display: block;\n        font-size: 14px;\n        margin-top: 4px;\n        text-decoration: none;\n        color: #222222;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Footer_wrap__VjkLj`,
	"topContainer": `Footer_topContainer__1FH+W`,
	"bottomContainer": `Footer_bottomContainer__-+4PP`,
	"topLogo": `Footer_topLogo__fAq7F`,
	"topLink": `Footer_topLink__j4tAP`,
	"topLinkItem": `Footer_topLinkItem__0oQeE`,
	"hoverItem": `Footer_hoverItem__qvjav`,
	"topHr": `Footer_topHr__fOoke`,
	"bottomSelect": `Footer_bottomSelect__VfOh4`,
	"bottomInfo": `Footer_bottomInfo__hRZH8`,
	"postContainer": `Footer_postContainer__9N-+Z`,
	"selectBox": `Footer_selectBox__kMZX1`,
	"show": `Footer_show__8J2Ez`,
	"selectBoxHr": `Footer_selectBoxHr__AvtEY`,
	"selectBoxWrap": `Footer_selectBoxWrap__0MdeH`,
	"selectBoxContent": `Footer_selectBoxContent__fKhqp`,
	"open": `Footer_open__-WlIi`,
	"doubleContent": `Footer_doubleContent__8VXy0`
};
export default ___CSS_LOADER_EXPORT___;
